import React from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import { DialogContent } from '@mui/material';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextInput from '../../components/Form/TextInput';
import { useCommonSlice } from '../../../store/commonSlice';
import { useCreateBannerMutation } from '../../../services/bannerApi';
import yup from 'utils/types/helpText';
import useMessage from '../../../utils/customHooks/useMessage';
import ImageUploadV from '../../components/Form/ImageUploadV';
import { eventApi } from '../../../services/eventApi';

const valid = yup.object().shape({
  title: yup
    .string()
    .max(255, 'タイトルが無効です')
    .required('タイトルが必須です'),
  image_url: yup.string().required('画像URLが必須です'),
});

function AddForm() {
  const [createBanner, { isLoading, isSuccess, isError, error }] =
    useCreateBannerMutation();

  const { actions } = useCommonSlice();
  const dispatch = useDispatch();

  const methods = useForm<any>({ resolver: yupResolver(valid) });

  useMessage(isLoading, isError, isSuccess, error, true);

  const onSubmit: SubmitHandler<any> = data => {
    createBanner(JSON.stringify(data));
    if (isSuccess) {
      dispatch(eventApi.endpoints.getFormModalBannerPoint.initiate());
    }
  };
  return (
    <DialogContent>
      <Box component={'form'} onSubmit={methods.handleSubmit(onSubmit)}>
        <FormProvider {...methods}>
          <Stack spacing={3}>
            <TextInput
              name={'title'}
              labelName={'バナー名'}
              defaultValue={''}
              showLabel={true}
            />
            <TextInput
              name={'description'}
              labelName={'バナー詳細'}
              defaultValue={''}
              showLabel={true}
            />
            <TextInput
              name={'transition_url'}
              labelName={'遷移URL'}
              defaultValue={''}
              showLabel={true}
            />
            <Box>
              <ImageUploadV
                limit={1}
                name={'image_url'}
                labelName={'画像URL'}
                showLabel={true}
                showLabelTextInput={false}
              />
            </Box>
          </Stack>
          <Stack
            flexDirection={'row'}
            justifyContent={'flex-end'}
            columnGap={2}
            mt={4}
          >
            <Button
              type={'button'}
              sx={{ color: '#5B5A5A' }}
              onClick={() => dispatch(actions.closeModal())}
            >
              Cancel
            </Button>
            <Button type={'submit'}>ADD</Button>
          </Stack>
        </FormProvider>
      </Box>
    </DialogContent>
  );
}

export default AddForm;
